import h from 'react-hyperscript';

import './Team.css';

import Section from '../../Section';

const TeamLeaders = [
  {
    name: 'Kurtis Dilyard',
    title: 'Founder / Chief Analytics Officer',
    thumbUrl: 'img/team-leader-pic1.jpg',
    desc: `Kurtis has spent ${new Date().getFullYear() -
      2002} years administering and organizing data to support analytics and intelligence.  He understands the importance of running data-driven businesses and provides modern frameworks which empower people to win the day.`,
    social: [{ name: 'linkedin', href: 'https://www.linkedin.com/in/kurtis-dilyard-b125079/' }],
  },

  {
    name: 'Nate Clark',
    title: 'Founder / Chief Technology Officer',
    thumbUrl: 'https://en.gravatar.com/userimage/121374230/fee939311b2ac2dfa3f9b7cb5a98a662.jpg?size=400',
    desc: `Nate has over ${new Date().getFullYear() -
      2003} years experince building enterprise software. He knows how to leverage cutting edge technologies to streamline your events.`,
    social: [
      { name: 'linkedin', href: 'https://www.linkedin.com/in/n8clark' },
      { name: 'twitter', href: 'https://twitter.com/n8c14rk' },
    ],
  },
].map(({ name, title, thumbUrl, desc, social }) =>
  h('.team-leader-box', [
    h('.team-leader.wow.fadeInDown.delay-03s', [
      h('.team-leader-shadow'),
      h('img', { src: thumbUrl }),
      h('ul', social.map(s => h('li', [h('a', { href: s.href }, h(`i.fa.fa-${s.name}`))]))),
    ]),

    h('h3.wow.fadeInDown.delay-03s', name),
    h('span.wow.fadeInDown.delay-03s', title),
    h('p.wow.fadeInDown.delay-03s', desc),
  ]),
);

const Team = () =>
  h(Section, { id: 'team', className: 'team' }, [
    h('h2', 'Team'),
    h('h6', 'Take a closer look into our amazing team. We won’t bite.'),
    h('.team-leader-block.clearfix', TeamLeaders),
  ]);

export default Team;



// WEBPACK FOOTER //
// ./src/components/Sections/Team/Team.js